import {
  DownloadOutlined,
  LeftOutlined,
  MessageOutlined,
  RightOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  List,
  Modal,
  Result,
  Row,
  Space,
  Spin,
  Tooltip,
  message
} from 'antd';
import '../../components/FirmaView';

import FileSaver from 'file-saver';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Document, Page, pdfjs } from 'react-pdf';
import { useHistory } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';
import { Title } from '../../components';
import CustomCopyable from '../../components/CustomCopyable';
import Firma from '../../components/Firma';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import EmpresaContext from '../../context/empresa-context';
import { b64toBlob } from '../../functions/images';
import { errorHandler, parseCelular } from '../../utils';
import { instanceRef } from '../../utils/axios';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = {
  aceptoContainer: { textAlign: 'justify', paddingTop: 40, paddingBottom: 40 },
  acepto: {
    fontSize: 17,
    fontWeight: 'bold',
    textalign: 'justify',
    display: 'flex',
    alignItems: 'center'
  },
  list: {
    textAlign: 'left',
    maxWidth: 500,
    margin: 'auto',
    marginTop: 40
  },
  icon: { fontSize: 20 }
};

const scrollToRef = (ref) => {
  if (ref && ref.current) {
    const headerOffset = 64;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = ref.current.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

const textoAceptar =
  'El que suscribe, responsablemente declara que todos los datos consignados se ajustan enteramente a la verdad y que no ha hecho omisión u ocultamiento intencional de hechos o informaciones relacionadas con la denuncia. Así como también el uso de la firma electrónica según la Ley 4.017.';

function FirmaDenuncia(props) {
  const { match } = props;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const history = useHistory();
  const [form] = Form.useForm();
  const myRef = useRef(null);
  const scrollTop = () => scrollToRef(myRef);
  const [loading, setLoading] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [sent, setSent] = useState(false);
  const confirmado = false;
  const [siniestro, setSiniestro] = useState();
  const [numPages, setNumPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [documentos, setDocumentos] = useState([]);
  const [dialogConfig, setDialogConfig] = useState(false);
  const [firma, setFirma] = useState();
  const [acepto, setAcepto] = useState(false);
  const { empresa } = useContext(EmpresaContext);
  const [canal, setCanal] = useState();

  const getDescripcionDocumento = (descripcion) => {
    switch (descripcion) {
      case 'Formulario.pdf':
        return 'Formulario';
      case 'DenunciaSiniestro':
        return 'Denuncia de Siniestro';
      default:
        return 'Denuncia de Siniestro';
    }
  };

  const enviarDenuncia = async () => {
    try {
      setLoading(true);
      setEnviando(true);
      const siniestroEnviar = {
        firma
      };
      const reCaptchaToken = await executeRecaptcha('form/siniestro/firmar');
      const response = await instanceRef.instance.post(
        `form/siniestro/firmar?token=${props.match.params.token}`,
        {
          ...siniestroEnviar,
          reCaptchaToken
        }
      );
      setSiniestro(response.data.data);
      getSiniestro();
      setEnviando(false);
      setLoading(false);
      setSent(true);
      scrollTop();
    } catch (error) {
      setEnviando(false);
      setLoading(false);
      errorHandler(error, 'No se pudo firmar la denuncia');
    }
  };

  const getSiniestro = async () => {
    instanceRef.instance
      .get(`/siniestro/${props.match.params.token}`)
      .then((res) => {
        setSiniestro(res.data.data);
        const viaWhatsapp =
          empresa.tiene_whatsapp &&
          res.data.data.poliza?.solicitud?.cotizacion?.persona?.via_contacto ===
            'whatsapp';

        setCanal(viaWhatsapp ? 'Whatsapp' : 'SMS');
      })
      .catch((err) => {
        errorHandler(err, err.message);
      });
  };

  const getDocumentos = async () => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.post(
        `form/siniestro/documentos?token=${props.match.params.token}`,
        {
          firma
        }
      );
      if (response.data.data && response.data.data.length === 0) {
        message.error('No se han encontrado los documentos');
        setLoading(false);
      } else {
        setDocumentos(
          response.data.data.map(({ filename, content }) => ({
            filename: getDescripcionDocumento(filename),
            content
          }))
        );
        setLoading(false);
      }
    } catch (error) {
      message.error('No se han encontrado los documentos');
      setLoading(false);
    }
  };

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  const nextPage = () => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const sendSms = async () => {
    try {
      const reCaptchaToken = await executeRecaptcha('sms/siniestro');
      const data = {
        reCaptchaToken,
        token: siniestro.token,
        idEmpresa:
          siniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa.id_empresa
      };
      message.info(
        `${siniestro.poliza.solicitud.cotizacion.persona.celular} recibirá un mensaje de texto para firmar el documento`
      );
      await instanceRef.instance.post(`sms/siniestro`, data);
      history.push('/');
    } catch (error) {
      // error
    }
  };

  useEffect(() => {
    getSiniestro();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (siniestro && siniestro.etapa === 'PENDIENTE_FIRMA') {
      getDocumentos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firma, siniestro]);

  const downloadFile = (file, name) => {
    const blob = b64toBlob(file, 'application/pdf');
    FileSaver.saveAs(blob, name);

    // const blobUrl = URL.createObjectURL(blob);
    // window.location = blobUrl;
  };
  const modalClassName = 'modal-header-document';

  return (
    <div>
      <LogosEmpresaAseguradora />
      <ResponsiveContainer>
        <Card>
          <div ref={myRef} />
          {loading}

          {!sent && siniestro && siniestro.etapa === 'PENDIENTE_FIRMA' && (
            <>
              <Form
                name="firma"
                initialValues={{}}
                onFinish={enviarDenuncia}
                scrollToFirstError
                form={form}
                layout="vertical"
                autoComplete="off"
              >
                <Modal
                  bodyStyle={{ padding: 0, paddingBottom: 20 }}
                  style={{ maxWidth: 1000 }}
                  className={modalClassName}
                  title={[
                    <div key="descargar">
                      {dialogConfig.title}
                      <span className="span-download-button">
                        <Button
                          type="dashed"
                          size="large"
                          icon={<DownloadOutlined />}
                          onClick={() =>
                            downloadFile(
                              dialogConfig.content,
                              dialogConfig.title
                            )
                          }
                        >
                          Descargar
                        </Button>
                      </span>
                    </div>
                  ]}
                  centered
                  open={dialogConfig.open}
                  afterClose={() =>
                    setDialogConfig({
                      open: false,
                      content: undefined,
                      title: ''
                    })
                  }
                  onCancel={() =>
                    setDialogConfig({
                      open: false,
                      content: undefined,
                      title: ''
                    })
                  }
                  footer={null}
                  width="90%"
                >
                  <div>
                    {dialogConfig.content && (
                      <SizeMe>
                        {({ size }) => (
                          <Document
                            onLoadSuccess={onDocumentLoadSuccess}
                            loading={<Spin />}
                            file={`data:application/pdf;base64,${dialogConfig.content}`}
                            style={{ height: 500 }}
                          >
                            <Page
                              key={`page_${currentPage + 1}`}
                              pageNumber={currentPage + 1}
                              width={size.width ? size.width : 1}
                            />
                            <div style={{ textAlign: 'center' }}>
                              <Button
                                type="link"
                                onClick={() => previousPage()}
                                disabled={currentPage === 0}
                              >
                                <LeftOutlined />
                                Anterior
                              </Button>
                              Pág. {currentPage + 1} de {numPages}
                              <Button
                                type="link"
                                onClick={() => nextPage()}
                                disabled={currentPage + 1 === numPages}
                              >
                                Siguiente
                                <RightOutlined />
                              </Button>
                            </div>
                          </Document>
                        )}
                      </SizeMe>
                    )}
                  </div>
                </Modal>
                <Spin
                  delay={500}
                  spinning={loading}
                  tip={enviando && 'En proceso. Aguarde un momento...'}
                >
                  <Title>Firma de Documentos</Title>
                  <List
                    footer={
                      <div>
                        <Row justify="space-between" align="middle">
                          <Col>
                            <Firma
                              error={!firma}
                              text={
                                !firma
                                  ? 'Firmar documentos'
                                  : 'Documentos firmados'
                              }
                              disabled={confirmado}
                              onSuccess={(value) =>
                                setFirma(value.split(',')[1])
                              }
                            />
                          </Col>
                          <Col>
                            <Row>
                              {siniestro?.poliza.solicitud.cotizacion?.persona
                                .celular &&
                                (empresa.tiene_sms ||
                                  empresa.tiene_whatsapp) && (
                                  <Col>
                                    <Tooltip
                                      title={`Enviar enlace para firmar a ${parseCelular(
                                        siniestro.poliza.solicitud.cotizacion
                                          .persona.celular
                                      )}`}
                                    >
                                      <Button
                                        type="text"
                                        onClick={() => {
                                          sendSms();
                                        }}
                                        icon={<MessageOutlined />}
                                      >
                                        Enviar por {canal}
                                      </Button>
                                    </Tooltip>
                                  </Col>
                                )}

                              <Col>
                                <Button
                                  type="text"
                                  icon={
                                    <CustomCopyable
                                      copyable={{
                                        text: `${window.location.origin}/firmar-denuncia/${match.params.token}`,
                                        tooltips: [
                                          'Copiar enlace para firmar',
                                          'Copiado'
                                        ]
                                      }}
                                    />
                                  }
                                  size="middle"
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    }
                    dataSource={documentos}
                    size="large"
                    bordered
                    style={styles.list}
                    renderItem={(item) => (
                      <List.Item
                        actions={[
                          <Tooltip title="Ver">
                            <Button
                              type="text"
                              onClick={() => {
                                setCurrentPage(0);
                                setDialogConfig({
                                  open: true,
                                  content: item.content,
                                  title: item.filename
                                });
                              }}
                              icon={<SearchOutlined />}
                              size="middle"
                            />
                          </Tooltip>,
                          <Tooltip title="Descargar">
                            <Button
                              type="text"
                              icon={<DownloadOutlined />}
                              onClick={() =>
                                downloadFile(item.content, item.filename)
                              }
                              size="middle"
                            />
                          </Tooltip>
                        ]}
                      >
                        <List.Item.Meta title={item.filename} />
                      </List.Item>
                    )}
                  />
                </Spin>
                <Row
                  gutter={[16, 0]}
                  justify="center"
                  align="middle"
                  style={styles.aceptoContainer}
                >
                  <Col xs={24} md={18}>
                    <Checkbox
                      checked={acepto}
                      disabled={confirmado}
                      onChange={(e) => setAcepto(e.target.checked)}
                      style={styles.acepto}
                    >
                      {textoAceptar}
                    </Checkbox>
                  </Col>
                </Row>
                {!confirmado && (
                  <>
                    <Tooltip
                      title={
                        !acepto
                          ? 'Debe aceptar las condiciones y firmar los documentos'
                          : ''
                      }
                    >
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={!acepto || !firma}
                        loading={loading || enviando}
                      >
                        Firmar denuncia
                      </Button>
                    </Tooltip>
                  </>
                )}
              </Form>
            </>
          )}
          {sent && (
            <div style={styles.content}>
              <Result
                status="success"
                title="¡Denuncia realizada exitosamente!"
                subTitle=""
                extra={[
                  <Space key="extras">
                    <Button
                      type="outlined"
                      key="console"
                      onClick={() => {
                        window.location.href = `/`;
                      }}
                    >
                      Ir al inicio
                    </Button>
                    <Button
                      type="primary"
                      key="console"
                      onClick={() => {
                        window.location.href = `${window.location.origin}/siniestros/form/${props.match.params.token}`;
                      }}
                    >
                      Continuar Inspección
                    </Button>
                  </Space>
                ]}
              />
            </div>
          )}
          {!sent && siniestro && siniestro.etapa === 'FIRMADA' && (
            <div style={styles.content}>
              <Result
                status="success"
                title="¡La denuncia ya ha sido firmada!"
                subTitle=""
                extra={[
                  <Button
                    type="primary"
                    key="console"
                    onClick={() => {
                      window.location.href = `/`;
                    }}
                  >
                    Ir al inicio
                  </Button>
                ]}
              />
            </div>
          )}
          {siniestro &&
            siniestro.etapa !== 'PENDIENTE_FIRMA' &&
            siniestro.etapa !== 'FIRMADA' && (
              <Result
                status="warning"
                title="¡Acción no permitida!"
                extra={[
                  <Button
                    type="primary"
                    key="console"
                    onClick={() => {
                      window.location.href = `/siniestros`;
                    }}
                  >
                    Volver al listado
                  </Button>
                ]}
              />
            )}
        </Card>
      </ResponsiveContainer>
    </div>
  );
}

export default FirmaDenuncia;
